import type { FileSource, LegacyFileSourceKeys } from './props.dictionary'

export type ProcessAction = {
  name: string
  actionName: string
  keys: any[]
  type: ProcessActionType
  triggerEvent: ProcessActionTriggerEvent
  endpoint: string
  params: ProcessActionParams
  customBody: any
  tokenUuid: string
  context: string
  // Where the ActionDefinition lives, when that differs from `context` (where the
  // UiAction is defined) — cross-process TAB actions configured from an embedded
  // child process. Runtime-only, absent for same-process actions.
  actionContext?: string
  processName?: string
  uiTemplateId?: number
  nodeDefinitionId?: number
  clientDataKeys?: string[]
  uiActionFlowxUuid: string
  id: string
  resourceDefinitionId: string
  templateConfigId: number
  reusableUiTemplateContext?: string
  resourceReference?: {
    resourceDefinitionId: string
    appId: string
    flowxUuid: string
  } | null
  order?: number
}

export type FlowMapping = {
  sourceStringPath: string
  targetStringPath: string
}
export type FlowMappings = Record<string, Record<'INPUT' | 'OUTPUT', FlowMapping[]>>

export enum ProcessActionType {
  DISMISS = 'DISMISS',
  ACTION = 'ACTION',
  START_PROJECT = 'START_PROJECT',
  UPLOAD = 'UPLOAD',
  EXTERNAL = 'EXTERNAL',
  START_PROCESS_INHERIT = 'START_PROCESS_INHERIT',
  START_PROCESS = 'START_PROCESS',
  START_WORKFLOW = 'START_WORKFLOW',
  NAVIGATE_TO = 'NAVIGATE_TO',
  UI_EVENT = 'UI_EVENT',
  AI_TRIGGER = 'AI_TRIGGER',
  DOWNLOAD = 'DOWNLOAD',
  SAVE_LOCAL_VARIABLE = 'SAVE_LOCAL_VARIABLE',
}

export enum ProcessActionTriggerEvent {
  CLICK = 'CLICK',
  CHANGE = 'CHANGE',
  LOAD = 'LOAD',
  DISPLAY = 'DISPLAY',
  SCROLL = 'SCROLL',
  DOCUMENT_END = 'DOCUMENT_END',
  PROCESS_END = 'PROCESS_END',
}

export type ProcessActionParams = {
  validate: boolean
  formsToSubmit: string[]
  blocksUi: boolean
  dismissProcess?: boolean
  dismissModal?: boolean
  newTab?: boolean
  collectionItemSaveKey?: string
  responseKey?: string
  analytics?: string
  analyticsCustomPayload?: string
  customKeys: string[]
  processName?: string
  process: {
    appId?: string
    resDefId?: string
    startParams?: string
  }
  workflow?: {
    appId?: string
    resDefId?: string
    startParams?: string
  }
  destination?: {
    uiTemplateFlowxUuid: string
    queryParams?: string
  }
  expression?: string
  aiTriggerParams?: string
  triggerCondition?: string
  document?: FileSource & LegacyFileSourceKeys
}

export type NavigateToResult = { kind: 'modal-same-root' } | { kind: 'navigate'; viewId: string }
